export default __webpack_public_path__ + "static/media/Ell of Torment.a4b2463b.jpg";